import {
  AdminPreQualificationIncomeSource,
  AdminPreQualificationIncomeSourcesValue,
} from '../models/preQualificationModel';

const ASSETS_BASE_URL =
  process.env.REACT_APP_ASSETS_URL ||
  'https://storage.googleapis.com/47a148dd-assets';

export const isIncomeSourcesValue = (
  value: unknown
): value is AdminPreQualificationIncomeSourcesValue =>
  typeof value === 'object' &&
  value !== null &&
  Array.isArray((value as AdminPreQualificationIncomeSourcesValue).sources);

export const getSourceFileUrl = (
  source: AdminPreQualificationIncomeSource
): string =>
  /^https?:\/\//i.test(source.filePath)
    ? source.filePath
    : `${ASSETS_BASE_URL}/${source.filePath.replace(/^\/+/, '')}`;

export const humanize = (text: string): string =>
  text.replace(/_/g, ' ').replace(/^\w/, (c) => c.toUpperCase());

export const formatAmount = (amount: number, currency: string): string =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency || 'USD',
  }).format(amount);
